module.exports = __webpack_public_path__ + "assets/img/kv-d16e0c6f.jpg";